module.exports = __webpack_public_path__ + "img/pc-help-2.a89b782e.jpg";